<template>
    <section id="finreport" class="dashboard-statement dashboard-area">

        <div class="dashboard_contents dashboard_statement_area">

            <div class="row">
                <div class="col-md-12">
                    <div class="dashboard_title_area">
                        <div class="dashboard__title">
                            <h3 v-if="!authUser" class="text-center w-100 mb-4">Поступления и расходы</h3>
                            <div class="date_area w-100">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 col-lg-2 mb-2">
                                        <date-picker class="dattaPikkara" v-model="date_start" valueType="DD-MM-YYYY"
                                                     placeholder="C даты"></date-picker>

                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-2 mb-2">
                                        <date-picker class="dattaPikkara" v-model="date_end" valueType="format"
                                                     placeholder="По дату"></date-picker>

                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-3 mb-2">
                                        <div class="select-wrap w-100">
                                            <select name="transaction_type" v-model="filter_type">
                                                <option value="-1">Тип транзакции</option>
                                                <option value="TYPE_DONATION">Приход</option>
                                                <option value="TYPE_SPENT">Расход</option>
                                            </select>
                                            <span class="lnr lnr-chevron-down"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-3 mb-2">
                                        <div class="select-wrap w-100">
                                            <select name="transaction_type" v-model="filterPetOrProjectId">
                                                <option value="-1">По получателю</option>
                                                <option :value="'pet-' + pet.id" v-for="pet in petsList">{{ pet.name }}
                                                    (питомец)
                                                </option>
                                                <option :value="'project-' + project.id"
                                                        v-for="project in projectsList">{{ project.name }} (проект)
                                                </option>
                                            </select>
                                            <span class="lnr lnr-chevron-down"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-12 col-lg-2">
                                        <button type="submit" class="btn btn--sm btn--round btn--color1 w-100"
                                                @click="getTransactionsList(true)">Поиск
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end /.col-md-12 -->
            </div>
            <!-- end /.row -->

            <div class="row">
                <div class="col-lg-4 col-md-4">
                    <div class="statement_info_card">
                        <div class="info_wrap">
                            <span class="lnr lnr-tag icon mcolorbg1"></span>
                            <div class="info">
                                <p>BYN {{ totalIncome }}</p>
                                <span>Поступлений</span>
                            </div>
                        </div>
                        <!-- end /.info_wrap -->
                    </div>
                    <!-- end /.statement_info_card -->
                </div>
                <!-- end /.col-md-3 -->

                <div class="col-lg-4 col-md-4" v-if="filterPetOrProjectId === '-1'">
                    <div class="statement_info_card">
                        <div class="info_wrap">
                            <span class="lnr lnr-cart icon mcolorbg2"></span>
                            <div class="info">
                                <p>BYN {{ totalExpenditures.expenditures }}</p>
                                <span>Расходов</span>
                            </div>
                        </div>
                        <!-- end /.info_wrap -->
                    </div>
                    <!-- end /.statement_info_card -->
                </div>

                <div class="col-lg-4 col-md-4" v-else>
                    <div class="statement_info_card">
                        <div class="info_wrap">
                            <span class="lnr lnr-cart icon mcolorbg2"></span>
                            <div class="info">
                                <p>BYN {{ totalExpenditures.spent }}<br> BYN {{totalExpenditures.transferred}}</p>
                                <span>Траты/Переводы</span>
                            </div>
                        </div>
                        <!-- end /.info_wrap -->
                    </div>
                    <!-- end /.statement_info_card -->
                </div>

                <!-- end /.col-md-3 -->

                <div class="col-lg-4 col-md-4">
                    <div class="statement_info_card">
                        <div class="info_wrap">
                            <span class="lnr lnr-database icon mcolorbg3"></span>
                            <div class="info">
                                <p>BYN {{ totalBalance }}</p>
                                <span>Баланс</span>
                            </div>
                        </div>
                        <!-- end /.info_wrap -->
                    </div>
                    <!-- end /.statement_info_card -->
                </div>
                <!-- end /.col-md-3 -->

                <div v-if="authUser === userId"
                     class="col-lg-12 col-md-12 d-flex justify-content-center align-items-center">
                    <div class="modals-nav d-flex">
                        <a href="#" class="btn btn--lg btn--round btn--color1" data-target="#moveMoney"
                           data-toggle="modal">Перевод средств</a>
                        <a href="/expenditure" class="btn btn--lg btn--round btn--color1">Запросить расход</a>
                    </div>
                </div>
                <!-- end /.col-md-3 -->
            </div>
            <!-- end /.row -->

            <div class="row">
                <div class="col-md-12">
                    <div class="statement_table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>Дата</th>
                                <th>Подопечный</th>
                                <th>Комментарий</th>
                                <th>Детали</th>
                                <th>Тип</th>
                                <th>Цена</th>
                                <th>Чек</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="transaction in transactionsList">
                                <td>{{ transaction.date }}</td>
                                <td class="author">
                                    <a v-if="transaction.pet" :href="'/pets/' + transaction.pet.id"
                                       target="_blank">{{ transaction.pet.name }}</a>
                                    <a v-if="transaction.project" :href="'/projects/' + transaction.project.id"
                                       target="_blank">{{ transaction.project.name }}</a>
                                </td>
                                <td class="comment">
                                    <span v-if="transaction.comment">{{ transaction.comment.substr(0, 50) }}</span>
                                    <span
                                        v-else-if="transaction.expenditureRequest && transaction.expenditureRequest.purpose">{{
                                            transaction.expenditureRequest.purpose
                                        }}</span>
                                    <span v-else></span>
                                </td>

                                <td class="detail">
                                    <span
                                        v-if="transaction.expenditureRequest && (transaction.type === 'TYPE_GOT_FUNDS' || transaction.type === 'TYPE_GOT_OWNED_FUNDS')">
                                        <span v-if="transaction.expenditureRequest.expenditure">{{ transaction.expenditureRequest.expenditure.name }}</span>
                                        <span
                                            v-if="transaction.expenditureRequest.source && transaction.expenditureRequest.source_type">
                                            от
                                            <a v-if="transaction.expenditureRequest.source_type && transaction.expenditureRequest.source_type.indexOf('Pet') >= 0"
                                               :href="`/pets/${transaction.expenditureRequest.source.id}`">
                                                {{ transaction.expenditureRequest.source.name }}
                                            </a>
                                            <a v-if="transaction.expenditureRequest.source_type.indexOf('Project') >= 0"
                                               :href="`/projects/${transaction.expenditureRequest.source.id}`">
                                                {{ transaction.expenditureRequest.source.name }}
                                            </a>
                                        </span>
                                    </span>
                                    <span
                                        v-else-if="transaction.expenditureRequest && (transaction.type === 'TYPE_SPENT' || transaction.type === 'TYPE_SPENT_TRANSFERRED')">
                                        <span v-if="transaction.expenditureRequest.expenditure">{{ transaction.expenditureRequest.expenditure.name }}</span>
                                        <span
                                            v-if="transaction.expenditureRequest.target && transaction.expenditureRequest.target_type">
                                            для
                                            <a v-if="transaction.expenditureRequest.target_type && transaction.expenditureRequest.target_type.indexOf('Pet') >= 0"
                                               :href="`/pets/${transaction.expenditureRequest.target.id}`">
                                                {{ transaction.expenditureRequest.target.name }}
                                            </a>
                                            <a v-if="transaction.expenditureRequest.target_type && transaction.expenditureRequest.target_type.indexOf('Project') >= 0"
                                               :href="`/projects/${transaction.expenditureRequest.target.id}`">
                                                {{ transaction.expenditureRequest.target.name }}
                                            </a>
                                        </span>
                                        <a href="#"
                                           class="review-link"
                                           v-if="transaction.expenditureRequest.contractor && !transaction.expenditureRequest.reviews.length"
                                           @click.prevent="$store.commit('setUserNeedReview', {
                                               'id': transaction.expenditureRequest.contractor.id,
                                               'name': transaction.expenditureRequest.contractor.name,
                                               'expenditure_request_id': transaction.expenditure_request_id,
                                               })"
                                        >Оставить отзыв для <br /><span class="font-weight-bold">"{{transaction.expenditureRequest.contractor.name}}"</span></a>
                                    </span>
                                    <span v-else>{{ transaction.expenditure.name }}</span>
                                </td>

                                <td class="type">
                                    <span
                                        :class="{sale : transaction.type === 'TYPE_DONATION' || transaction.type === 'TYPE_GOT_FUNDS' || transaction.type === 'TYPE_GOT_OWNED_FUNDS',
                                                 purchase: transaction.type === 'TYPE_SPENT', withdrawal: transaction.type === 'TYPE_SPENT_TRANSFERRED'}">
                                        {{
                                            transaction.type === 'TYPE_DONATION' || transaction.type === 'TYPE_GOT_FUNDS' ||
                                            transaction.type === 'TYPE_GOT_OWNED_FUNDS' ? 'Приход' : transaction.type === 'TYPE_SPENT_TRANSFERRED' ? 'Перевод' : 'Расход'
                                        }}
                                    </span>
                                </td>
                                <td>{{
                                        transaction.type === 'TYPE_DONATION' || transaction.type === 'TYPE_GOT_FUNDS' || transaction.type === 'TYPE_GOT_OWNED_FUNDS' ? transaction.credit : transaction.debit
                                    }} BYN
                                </td>
                                <td class="action">
                                    <a v-if="transaction.type === 'TYPE_SPENT' && transaction.images && transaction.images.length"
                                       href="#" data-target="#modalChecks" data-toggle="modal"
                                       @click="openChecksModal(transaction.id)">Чек</a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="pagination-area  mb-5" v-if="pageCount">
                            <nav class="navigation pagination" role="navigation">
                                <div class="nav-links">
                                    <paginate
                                        v-model="page"
                                        :page-count="pageCount"
                                        :click-handler="paginateClickCallback"
                                        :prev-text="''"
                                        :next-text="''"
                                        :container-class="'className'"
                                        :page-class="'page-numbers'"
                                        :page-link-class="''"
                                        :active-class="'current'"
                                        :prev-class="'prev page-numbers'"
                                        :prev-link-class="'lnr lnr-arrow-left'"
                                        :next-class="'next page-numbers'"
                                        :next-link-class="'lnr lnr-arrow-right'"
                                    >
                                    </paginate>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end /.row -->

        </div>
        <!-- Модальное окно для перевода средств -->
        <div class="modal fade" id="moveMoney" tabindex="-1" role="dialog" aria-labelledby="rating_modal">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h3 class="modal-title">Перевод</h3>
                    </div>
                    <!-- end /.modal-header -->

                    <div class="modal-body">
                        <div v-if="modalMoveFundsStatus === 'ready' || modalMoveFundsStatus === 'pending'" class="row">
                            <div class="col-sm-12">
                                <p class="mb-1">От кого</p>
                                <div class="select-wrap">
                                    <select v-model="$v.moveFundsForm.fromPetOrProject.$model"
                                            @change="calcToAndFrom('from')">
                                        <template
                                            v-for="pet in userPerAndProjects.pets.filter(item => item.available_funds > 0)">
                                            <option :value="pet">{{ pet.name }} (питомец, доступно
                                                {{ pet.available_funds }} BYN)
                                            </option>
                                        </template>

                                        <template
                                            v-for="project in userPerAndProjects.projects.filter(item => item.available_funds > 0)">
                                            <option :value="project">{{ project.name }} (проект, доступно
                                                {{ project.available_funds }} BYN)
                                            </option>
                                        </template>

                                    </select>
                                    <span class="lnr lnr-chevron-down"></span>
                                </div>
                                <div class="field-error-text" v-if="$v.moveFundsForm.fromPetOrProject.$error">-
                                    Необходимо указать, от кого переводить деньги
                                </div>
                            </div>
                            <div class="col-sm-12 mt-3">
                                <div class="radio-group">
                                    <p class="label mb-1">Кому</p>
                                    <div class="custom-radio">
                                        <input type="radio" id="type1" value="my" v-model="moveFundsToType">
                                        <label for="type1"><span class="circle"></span>Своим подопечным</label>
                                    </div>
                                    <div class="custom-radio">
                                        <input type="radio" id="type2" value="other" v-model="moveFundsToType">
                                        <label for="type2"><span class="circle"></span>Чужим подопечным</label>
                                    </div>
                                </div>
                            </div>
                            <!-- Если перевод своим -->
                            <div class="col-sm-12 mt-3" v-if="moveFundsToType === 'my'" @change="calcToAndFrom('to')">
                                <div class="select-wrap">
                                    <select v-model="$v.moveFundsForm.toPetOrProject.$model">
                                        <option v-for="pet in userPerAndProjects.pets" :value="pet">{{ pet.name }}
                                            (Питомец)
                                        </option>
                                        <option v-for="project in userPerAndProjects.projects" :value="project">
                                            {{ project.name }} (Проект)
                                        </option>
                                    </select>
                                    <span class="lnr lnr-chevron-down"></span>
                                </div>
                                <div class="field-error-text" v-if="$v.moveFundsForm.toPetOrProject.$error">- Необходимо
                                    указать кому переводить деньги
                                </div>
                            </div>
                            <!-- Если перевод другим пользователям -->
                            <div class="col-sm-12 mt-3" v-if="moveFundsToType === 'other'">
                                <div class="search" v-if="!moveFundsForm.toPetOrProjectId">
                                    <input type="search" v-model="moveFundsToSearchInput"
                                           placeholder="Поиск. Начните вводить буквы">
                                    <div class="field-error-text" v-if="$v.moveFundsForm.toPetOrProject.$error">-
                                        Необходимо указать кому переводить деньги
                                    </div>
                                    <div class="search-results" v-if="moveFundsToSearchInput">
                                        <template v-for="type in ['petsWithNeedSum', 'pets', 'projects']">
                                            <template v-if="moveSearchResults[type].length">
                                                <div class="object-type">
                                                    {{
                                                        type === 'petsWithNeedSum' ? 'Нуждаются в помощи' : (type === 'pet' ? 'Ищут друга' : 'Проекты')
                                                    }}
                                                </div>
                                                <div class="search-items">
                                                    <div class="search-item" v-for="object in moveSearchResults[type]"
                                                         @click="selectMoveFundsTarget(type, object)">
                                                        <img :src="'/storage/' + object.avatar.path" alt="">
                                                        <div>
                                                            <div class="search-item-name">{{ object.name }}</div>
                                                            <div class="search-item-desc">{{ object.ad_title }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>

                                <div class="row mt-3" v-else>
                                    <div class="col-12">
                                        <p class="mb-0">Вы выбрали:</p>
                                        <div class="search-item selected">
                                            <span class="search-item-remove lnr lnr-cross-circle"
                                                  @click="deleteSelectedSearchItem"></span>
                                            <img :src="'/storage/' + moveFundsToSelectedObjectData.avatarUrl" alt="">
                                            <div>
                                                <div class="search-item-name">{{
                                                        moveFundsToSelectedObjectData.name
                                                    }}
                                                </div>
                                                <div class="search-item-desc">{{
                                                        moveFundsToSelectedObjectData.adTitle
                                                    }}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 mt-3">
                                <p>Сумма перевода (BYN)</p>
                                <div class="font-weight-bold display-4">
                                    <input type="number" min="0.01" max="100000" step="1"
                                           v-model="$v.moveFundsForm.amount.$model">
                                </div>
                                <div class="field-error-text" v-if="$v.moveFundsForm.amount.$error">- Сумма перевода
                                    указана неверно
                                </div>
                            </div>

                            <div class="col-sm-12 mt-3">
                                <label>Причина</label>
                                <textarea cols="30" rows="5" v-model="$v.moveFundsForm.comment.$model"></textarea>
                                <div class="field-error-text" v-if="$v.moveFundsForm.comment.$error">- Необходимо
                                    указать причину
                                </div>
                            </div>
                        </div>
                        <template v-if="modalMoveFundsStatus === 'success'">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Спасибо!</h3>
                                    <p>Заявка на перевод принята и будет опубликована после прохождения модерации.</p>
                                </div>
                            </div>
                        </template>
                        <div class="row mt-3">
                            <div class="col-md-6">
                                <button type="submit" class="btn btn--round btn--default w-100"
                                        @click="submitMoveFundsForm" v-if="modalMoveFundsStatus === 'ready'"
                                        :disabled="modalMoveFundsStatus === 'pending' || modalMoveFundsStatus === 'success'">
                                    {{ modalMoveFundsStatus === 'pending' ? 'Отправляется' : 'Отправить' }}
                                </button>
                            </div>
                            <div class="col-md-6 mt-2 mt-md-0">
                                <button class="btn btn--round btn--default w-100" data-dismiss="modal">Закрыть</button>
                            </div>
                        </div>
                    </div>
                    <!-- end /.modal-body -->
                </div>
            </div>
        </div>

        <div class="modal fade rating_modal" id="modalChecks" tabindex="-1" role="dialog"
             aria-labelledby="rating_modal">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h3 class="modal-title" id="checks_modal-title">Список чеков</h3>
                    </div>
                    <!-- end /.modal-header -->

                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6" v-for="(check, index) in checksList">
                                <div class="img-zoom-container">
                                    <img @click="previewImageIndex = index" :src="'/storage' + check.path" class="img-fluid">
                                </div>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 mt-2 mt-md-0">
                                <button class="btn btn--round btn--default w-100" data-dismiss="modal">Закрыть</button>
                            </div>
                        </div>
                    </div>
                    <!-- end /.modal-body -->
                </div>
            </div>
        </div>

        <image-preview :images="checksList" @reset-preview-selected="previewImageIndex = null" :selected-image="previewImageIndex" />

        <!-- end /.dashboard_menu_area -->
    </section>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ImagePreview from './ImagePreview'

import {maxLength, minValue, required} from 'vuelidate/lib/validators';

export default {
    data() {
        return {
            previewImageIndex: null,
            moment: window.moment,
            modalMoveFundsStatus: 'ready',
            userPerAndProjects: {
                pets: [],
                projects: []
            },
            moveFundsToSearchInput: '',
            moveFundsToType: 'my', //other
            moveFundsToSelectedObjectData: null,
            moveFundsForm: {
                fromType: null,
                toType: null,
                fromPetOrProject: null,
                fromPetOrProjectId: null,
                toPetOrProject: null,
                toPetOrProjectId: null,
                comment: null,
                amount: 0,
            },
            moveSearchResults: {
                pets: [],
                projects: [],
                petsWithNeedSum: []
            },

            // pickerLang: ru,
            appRoutes: null,
            pageCount: 100,
            page: 1,
            filterPetOrProjectId: '-1',
            filter_type: '-1',
            petsList: [],
            totalIncome: 0,
            totalExpenditures: {
                expenditures: 0,
                spent: 0,
                transferred: 0
            },
            totalBalance: 0,
            projectsList: [],
            transactionsList: [],
            checksList: [],
            date_start: null,
            date_end: null,
            expenditures: [],
            previewImages: [],
            images: [],
            media: null
        }
    },
    props: ['userId', 'authUser'],
    computed: {},
    created() {
        this.appRoutes = window.appRoutes;
        window.addEventListener("resize", this.myEventHandler);
    },
    destroyed() {
        window.removeEventListener("resize", this.myEventHandler);
    },
    mounted() {
        if (this.authUser > 0) {
            this.getInitData();
            this.loadPetsListWithTransactionsByVolunteer();
        }
        this.getFinanceReportTotals();
        this.getTransactionsList(true);
        this.getUserPetAndProjects();

        $('.modal').on('show.bs.modal', function (e) {
            $('html').addClass('modal-open')
        });
        $('.modal').on('hidden.bs.modal', function (e) {
            $('html').removeClass('modal-open')
        });
    },
    methods: {
        calcToAndFrom(move) {
            if (move === 'from') {
                this.moveFundsForm.fromPetOrProjectId = this.moveFundsForm.fromPetOrProject.id;
                this.moveFundsForm.fromType = this.moveFundsForm.fromPetOrProject.type;
            }
            if (move === 'to') {
                this.moveFundsForm.toPetOrProjectId = this.moveFundsForm.toPetOrProject.id;
                this.moveFundsForm.toType = this.moveFundsForm.toPetOrProject.type;
            }
        },
        getUserPetAndProjects() {
            let self = this;

            if (this.authUser > 0) {
                axios.get('/api/user/pets-n-projects')
                    .then(response => {
                        self.userPerAndProjects.pets = response.data.data.pets;
                        self.userPerAndProjects.projects = response.data.data.projects;
                    });
            }
        },
        deleteSelectedSearchItem() {
            this.moveFundsForm.toType = null;
            this.moveFundsForm.toPetOrProjectId = null
        },
        selectMoveFundsTarget(type, object) {
            this.moveFundsToSearchInput = '';
            this.moveFundsForm.toType = object.type === 'project' ? 'project' : 'pet';
            this.moveFundsForm.toPetOrProject = object;
            this.moveFundsForm.toPetOrProjectId = object.id;

            this.moveFundsToSelectedObjectData = {
                id: object.id,
                name: object.name,
                adTitle: object.adTitle,
                avatarUrl: object.avatarUrl,
            };
        },
        getSearchResults() {
            let self = this;
            let url = '/api/catalog/search';

            if (!self.moveFundsToSearchInput) return false;

            axios.get(url, {
                params: {
                    keyword: self.moveFundsToSearchInput
                }
            })
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        self.moveSearchResults.pets = response.data.pets;
                        self.moveSearchResults.projects = response.data.projects;
                        self.moveSearchResults.petsWithNeedSum = response.data.petsWithNeedSum;
                    } else {
                        alert('Произошла ошибка! Попробуйте перезагрузить страницу.');
                    }
                })
                .catch((error) => {

                })
                .then();
        },
        myEventHandler(e) {
            this.media = window.innerWidth
        },
        openChecksModal(transactionId) {
            let self = this;

            self.transactionsList.forEach(function (value, key, transactions) {
                if (transactions[key]['id'] == transactionId) {
                    self.checksList = transactions[key]['images'];
                }
            });
        },
        submitMoveFundsForm() {
            let self = this;

            self.modalMoveFundsStatus = 'pending';
            this.$v.moveFundsForm.$touch();

            if (this.$v.moveFundsForm.$error) {
                self.modalMoveFundsStatus = 'ready';
                return false;
            }

            let requestData = {
                source_pet_id: this.moveFundsForm.fromType === 'pet' ? this.moveFundsForm.fromPetOrProjectId : null,
                source_project_id: this.moveFundsForm.fromType === 'project' ? this.moveFundsForm.fromPetOrProjectId : null,

                target_pet_id: this.moveFundsForm.toType === 'pet' ? this.moveFundsForm.toPetOrProjectId : null,
                target_project_id: this.moveFundsForm.toType === 'project' ? this.moveFundsForm.toPetOrProjectId : null,

                type: 'move_funds_request',
                amount: this.moveFundsForm.amount,
                purpose: this.moveFundsForm.comment,
            };

            axios.post('/api/expenditure-requests', requestData)
                .then(response => {
                    self.modalMoveFundsStatus = 'success'

                    response = response.data;

                    if (response.success) {

                        setTimeout(() => {

                            this.moveFundsForm = {
                                fromType: null,
                                toType: null,
                                fromPetOrProject: null,
                                fromPetOrProjectId: null,
                                toPetOrProject: null,
                                toPetOrProjectId: null,
                                comment: null,
                                amount: 0,
                            }


                            self.modalMoveFundsStatus = 'ready';
                            self.$v.moveFundsForm.$reset();

                        }, 3000);


                    }
                })
                .catch(err => {
                    err = err.response.data

                    if (!err.success) {
                        self.modalMoveFundsStatus = 'ready';
                        console.log(err)

                    }

                })
        },
        paginateClickCallback(pageNum) {
            this.page = pageNum;
            this.getTransactionsList();
        },
        getInitData() {
            let self = this;
            let url = '/volunteer/' + this.userId + '/getInitData';

            axios.get(url)
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        self.expenditures = response.expenditures;

                    } else {
                        alert('Произошла ошибка! Попробуйте перезагрузить страницу.');
                    }
                })
                .catch((error) => {

                })
                .then();
        },
        loadPetsListWithTransactionsByVolunteer() {
            let self = this;
            let url = '/volunteer/' + this.userId + '/pets-projects-with-transactions';

            axios.get(url)
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        self.petsList = response.data.pets;
                        self.projectsList = response.data.projects;
                    } else {
                        alert('Произошла ошибка! Попробуйте перезагрузить страницу.');
                    }
                })
                .catch((error) => {

                })
                .then();
        },
        getTransactionsList(resetPage) {
            let self = this;
            let url = '/user/' + this.userId + '/supervised-transactions';

            if (resetPage) {
                this.page = 1;
            }

            let projectId = this.filterPetOrProjectId.indexOf('project-') !== -1 ? +this.filterPetOrProjectId.replace('project-', '') : null;
            let petId = this.filterPetOrProjectId.indexOf('pet-') !== -1 ? +this.filterPetOrProjectId.replace('pet-', '') : null;
            let transactionsType = self.filter_type !== '-1' ? self.filter_type : null;
            let params = {
                date_start: self.date_start,
                date_end: self.date_end,
                page: self.page,
                pet_id: petId,
                project_id: projectId,
                type: transactionsType,
            };

            axios.get(url, {
                params: params
            })
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        self.transactionsList = response.data;
                        self.pageCount = response.meta.last_page
                    } else {
                        alert('Произошла ошибка! Попробуйте перезагрузить страницу.');
                    }
                })
                .catch((error) => {

                })
                .then();
        },
        getFinanceReportTotals(url = `/user/${this.userId}/finance-report-totals`) {
            // Загружаем общие cчётчики
            let self = this;

            axios.get(url)
                .then(response => {
                    response = response.data;
                    self.totalIncome = parseFloat(response.data.income).toFixed(2);
                    self.totalExpenditures.expenditures = response.data.expenditures ? parseFloat(response.data.expenditures).toFixed(2) : 0;
                    self.totalExpenditures.spent = response.data.spent ? parseFloat(response.data.spent).toFixed(2) : 0;
                    self.totalExpenditures.transferred = response.data.transferred ? parseFloat(response.data.transferred).toFixed(2) : 0;
                    self.totalBalance = parseFloat(response.data.balance).toFixed(2);
                })
                .catch((error) => {

                })
                .then();
        },
    },
    watch: {
        moveFundsToType() {
            this.moveFundsForm.type = null;
            this.moveFundsForm.toPetOrProject = null;
            this.moveFundsForm.toPetOrProjectId = null;
        },
        moveFundsToSearchInput() {
            this.getSearchResults();
        },
        images() {
            let self = this;

            self.images.forEach(function (image) {
                if (typeof FileReader === "function") {
                    const reader = new FileReader();

                    reader.onload = event => {
                        if ($.inArray(event.target.result, self.previewImagesOnlyBase64) === -1) {
                            self.previewImages.push({
                                'base64': event.target.result,
                                'name': image.name,
                            });
                            // self.previewImagesOnlyBase64.push(event.target.result);
                            self.spentForm.images.push(image);

                        }
                    };

                    reader.readAsDataURL(image);
                }
            });
        },
        filterPetOrProjectId(){

            if(this.filterPetOrProjectId !== '-1'){
                let request = this.filterPetOrProjectId.indexOf('project-') >= 0 ?
                    `/projects/${this.filterPetOrProjectId.replace('project-','')}/finance-report-totals` :
                    `/pets/${this.filterPetOrProjectId.replace('pet-','')}/finance-report-totals`

                this.getFinanceReportTotals(request)

                console.log(this.request)

                return
            }

            this.getFinanceReportTotals()

        }
    },
    components: {
        DatePicker, ImagePreview
    },
    validations: {
        moveFundsForm: {
            amount: {
                required,
                minValue: minValue(0.01),
                val: function (value) {
                    if (this.moveFundsForm?.fromPetOrProject?.available_funds >= this.moveFundsForm.amount) {
                        return true
                    }

                    return false
                }
            },
            comment: {
                required
            },
            fromPetOrProject: {
                required
            },
            toPetOrProject: {
                required
            }
        },
        spentForm: {
            expenditureId: {
                required
            },

            amount: {
                required,
                minValue: minValue(0.01)
            },
            spentPetOrProjectId: {
                required
            },
            comment: {
                required,
                maxLength: maxLength(1000)
            }
        },
    }
}
</script>
<style lang="scss">

.modals-nav{
    margin: 0 -15px;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    .btn{
        margin: 15px 15px 0;
    }
}

.img-zoom-container {
    position: relative;
    margin: 10px 0 20px;

    img{
        cursor: pointer;
    }

}

.img-zoom-lens {
    position: absolute;
    border: 1px solid #d4d4d4;
    /*set the size of the lens:*/
    width: 40px;
    height: 40px;
}

img.active ~ .img-zoom-result {

}

.img-zoom-result {
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    border: 1px solid #d4d4d4;
    /*set the size of the result div:*/
    opacity: 0;
    transition: opacity .2s ease;
    pointer-events: none;
}

.img-zoom-container.active .img-zoom-result {
    opacity: 1;
}

.mx-input {
    line-height: 45px;
    height: 45px;
    border: 1px solid #ececec;
    border-radius: 2px;
    color: #747b86;
    font-size: 16px;

    &:focus,
    &:hover {
        border-color: #ececec;
    }
}

@media screen and (max-width: 768px) {
    .mx-datepicker {
        margin-bottom: 20px;
    }
}
</style>
<style lang="scss" scoped>

#finreport {
    table {
        th,td {
            font-size: 14px;
            vertical-align: top;
        }
    }
}

.review-link {
    display: block;
    border-radius: 10px;
    border: 2px solid #0674ec;
    font-size: 12px;
    padding: 2px 15px;
    text-align: center;
    line-height: 16px;
    margin-top: 5px;
}

.transactions-list {
    padding: 10px;
    border: 1px solid #ccc;
    height: 130px;
    box-sizing: border-box;
    overflow: auto;

    .transaction {
        label {
            display: flex;
            align-items: center;
            line-height: 27px;
            margin-bottom: 0;

            input {
                width: 15px;
                margin-right: 10px;
                height: inherit;
            }

        }
    }
}

.search {
    position: relative;
    text-align: left;

    .search-results {
        position: absolute;
        z-index: 2;
        background: #fff;
        box-shadow: 0 6px 6px 0 #d8d8d8;
        width: 100%;
        padding: 10px;
        max-height: 350px;
        overflow: auto;

        .object-type {
            text-align: center;
            font-weight: bold;
            margin-bottom: 5px;
        }

        .search-items {


        }
    }


}


.search-item.selected {
    background: #f6f6f6;
}

.search-item {
    padding: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;

    &:hover {
        background: #f6f6f6;
    }

    .search-item-remove {
        font-size: 17px;
        position: absolute;
        right: -6px;
        top: -7px;
        cursor: pointer;
        color: #6b6e70;
        background: white;
        font-weight: bold;
        z-index: 1000;
    }

    img {
        margin-right: 10px;
        width: 50px;
        min-width: 50px;
        border-radius: 15px;
    }

    .search-item-name {
        font-weight: bold;
    }

    .search-item-desc {
        font-size: 10px;
        color: #0674ec;
    }

}

.mx-datepicker {
    width: 100%;
}

.chat_area .chat_area--conversation, .recent_message .dashboard__content .chat_area--conversation {
    padding: 30px;
    max-height: 855px;
    overflow-Y: scroll;
    margin-right: 2px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}

.field-error-text {
    margin-top: 5px;
}
</style>
<style lang="scss">
.vdp-datepicker__calendar-button {
    position: absolute;
    right: 15px;
    top: 15px;
}
</style>
